import { Link } from 'react-router-dom';
import Button from '../../../components/base/Button';

export default function ServicesSection() {
  const services = [
    {
      title: 'Arquitetura de Alto Padrão',
      description: 'Projetos residenciais e comerciais exclusivos, desenvolvidos com sofisticação e personalidade única para cada cliente.',
      image: 'https://static.readdy.ai/image/50171caa7fe9961724fd6c723691a199/755b47b0598f8cd60524e79ef8799483.jpeg',
      features: ['Design personalizado', 'Materiais premium', 'Acompanhamento completo']
    },
    {
      title: 'Engenharia Premium',
      description: 'Integração completa entre projeto arquitetônico, estrutura e instalações, garantindo segurança e eficiência.',
      image: 'https://static.readdy.ai/image/50171caa7fe9961724fd6c723691a199/f73d21c32a0bf0a54871b89c8937a7b9.jpeg',
      features: ['Cálculos estruturais', 'Instalações integradas', 'Aprovações técnicas']
    },
    {
      title: 'Regularização e Documentação',
      description: 'Licenças, alvarás e toda documentação necessária sem dor de cabeça, com acompanhamento especializado.',
      image: 'https://static.readdy.ai/image/50171caa7fe9961724fd6c723691a199/775f1139237a88761eb8056e48ac2b4b.jpeg',
      features: ['Licenças e alvarás', 'Documentação completa', 'Suporte jurídico']
    },
    {
      title: 'Gestão de Obras',
      description: 'Acompanhamento técnico e administrativo completo, garantindo qualidade, prazo e orçamento controlados.',
      image: 'https://static.readdy.ai/image/50171caa7fe9961724fd6c723691a199/92382503a82339f2eb04098939acd2d5.jpeg',
      features: ['Supervisão técnica', 'Controle de qualidade', 'Gestão de cronograma']
    }
  ];

  return (
    <section id="services" className="py-16 bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-[#5C1A24] mb-4" style={{ fontFamily: '"Playfair Display", serif' }}>
            Nossos principais serviços
          </h2>
          <p className="text-lg text-[#3F3F3F] max-w-2xl mx-auto">
            Soluções completas em arquitetura e engenharia, pensadas para atender às mais altas exigências de qualidade e sofisticação.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12">
          {services.map((service, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300 group cursor-pointer"
            >
              <div className="relative overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-48 object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              </div>
              
              <div className="p-6">
                <h3 className="text-xl font-bold text-[#5C1A24] mb-3">
                  {service.title}
                </h3>
                <p className="text-[#3F3F3F] mb-4 leading-relaxed text-sm">
                  {service.description}
                </p>
                
                <div className="space-y-1 mb-4">
                  {service.features.map((feature, featureIndex) => (
                    <div key={featureIndex} className="flex items-center text-xs text-gray-600">
                      <i className="ri-check-line text-[#5C1A24] mr-2"></i>
                      {feature}
                    </div>
                  ))}
                </div>
                
                <Link to="/servicos" className="text-[#5C1A24] font-medium hover:text-[#4A1520] transition-colors cursor-pointer flex items-center text-sm">
                  Saiba mais
                  <i className="ri-arrow-right-line ml-2"></i>
                </Link>
              </div>
            </div>
          ))}
        </div>

        {/* CTA Section */}
        <div className="text-center">
          <div className="bg-[#E8E1DC] p-8 rounded-2xl">
            <h3 className="text-xl font-bold text-[#5C1A24] mb-3">
              Precisa de um serviço específico?
            </h3>
            <p className="text-[#3F3F3F] mb-6 max-w-xl mx-auto text-sm">
              Oferecemos soluções personalizadas para cada necessidade. Entre em contato e vamos conversar sobre seu projeto.
            </p>
            <a 
              href="https://wa.me/5511980341891?text=Olá! Gostaria de saber mais sobre os serviços da P&P Engenharia e Arquitetura."
              target="_blank"
              rel="noopener noreferrer"
            >
              <Button size="md">
                <i className="ri-service-line mr-2"></i>
                Conheça todos os nossos serviços
              </Button>
            </a>
          </div>
        </div>

      </div>
    </section>
  );
}
